import React, { useCallback, useState } from "react";
import { uuid } from "./../wix-rich-content-common/index.js";
import { Iframe } from "./iframe.js";
const IframeUrl = (props) => {
  const [currId] = useState(() => uuid());
  const [isLoaded, setIsLoaded] = useState(false);
  const handleIframeLoad = useCallback(() => {
    setIsLoaded(true);
    if (!window?.ricosHtmlPlugins) {
      window.ricosHtmlPlugins = /* @__PURE__ */ new Set();
    }
    window.ricosHtmlPlugins.add(currId);
  }, [currId]);
  React.useEffect(() => {
    const timeout = setTimeout(() => {
      if (!isLoaded) {
        handleIframeLoad();
      }
    }, 5e3);
    return () => clearTimeout(timeout);
  }, [isLoaded, handleIframeLoad]);
  return /* @__PURE__ */ React.createElement(
    Iframe,
    {
      ...props,
      onLoad: handleIframeLoad,
      sandbox: "allow-popups allow-presentation allow-forms allow-same-origin allow-scripts"
    }
  );
};
export {
  IframeUrl
};
//# sourceMappingURL=iframe-url.js.map
